(() => {
    "use strict";

    document.getElementById('nav-menu-toggle') && document.getElementById('nav-menu-toggle').addEventListener('click', function () {
        this.classList.toggle('nav-toggle--active');
        document.getElementById('nav').classList.toggle('nav--active');
        document.querySelector('html body').classList.toggle('locked');
    });

    document.querySelector('.faq__question') && document.querySelectorAll('.faq__question').forEach(function (item) {
        let isActive = true;

        item.addEventListener('click', function (evt) {
            const parentElement = evt.target.parentElement;
            parentElement.classList.toggle('faq--active', isActive);
            parentElement.querySelector('.faq__answer__container').style.height = (isActive ? parentElement.querySelector('.faq__answer').offsetHeight : 0) + 'px';
            
            isActive = !isActive;
        });
    });

    document.querySelector('[data-toggle]') && document.querySelectorAll('[data-toggle]').forEach(toggle => {
        toggle.addEventListener('click', evt => {
            document.querySelector('[data-element="' + evt.target.dataset.toggle + '"]').classList.toggle('active');
        });
    });

    document.querySelector('[data-aos]') && AOS.init({
        offset: 0,
        duration: 1200,
        disable: 'mobile',
        once: true
    });

    document.querySelector('#paperworks') && new Splide('#paperworks', {
        type: 'carousel',
        perPage: 1,
        perMove: 1,
        pagination: false,
        gap: '5vw'
    }).mount();
})();